




















import { Component, Mixins } from "vue-property-decorator";
import { NumberInput } from "../../../../../base/components/system";
import { ILengthAlertBehavior } from "../../../../../documaker/domain/format/objects";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";

@Component({
  components: {
    NumberInput,
  }
})
export default class LengthAlertBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ILengthAlertBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ILengthAlertBehavior) => T, defaultValue: T) => T;

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get length(): number {
    return this.readPropertyOrDefault(s => s.length, null);
  }

  set length(value: number) {
    this.writePropertyWhenValid(s => s.length = this.isValid(Math.floor(value)));
  }
  
  get shouldValidate(): boolean {
    return this.readPropertyOrDefault(s => s.shouldValidate, false);
  }

  set shouldValidate(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldValidate = value);
  }

  isValid(value: number): number {
    return (!isNaN(value) && (value > 0)) ? value : null;
  }
}
